import React from 'react';
import { Users } from 'lucide-react';

// Report recipients are managed in Admin → Notification Recipients (Reports & digests).
export const LeadReportRecipients = () => (
  <a href="/admin?tab=notification-recipients" className="inline-flex items-center gap-1 underline text-neutral-700 hover:text-neutral-900" data-testid="lead-report-manage-recipients"><Users className="w-3 h-3" />Recipients</a>
);
